<template>
  <b-modal id="createUserDataFirmModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.userdatafirm.createUserDataFirmHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <UserDataFirmCreate :userIRI="userIRI"></UserDataFirmCreate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import UserDataFirmCreate from '../Create.vue'
export default {
  name: 'CreateUserDataFirmModal',
  components: {
    UserDataFirmCreate
  },
  computed: {
    show () {
      return this.$store.state.modals.userdatafirm.create.show
    },
    computedUserIRI () {
      return this.$store.state.modals.userdatafirm.create.userIRI
    },
    close () {
      return this.$store.state.modals.userdatafirm.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      userIRI: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.computedUserIRI) {
        this.userIRI = this.$store.state.modals.userdatafirm.create.userIRI
        this.$store.state.modals.userdatafirm.create.show = 0
        this.$store.state.modals.userdatafirm.create.userIRI = null
        this.$bvModal.show('createUserDataFirmModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.userdatafirm.create.close = 0
        this.$bvModal.hide('createUserDataFirmModal')
      }
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
